import { Box, Grid, Typography } from "@mui/material"


const platforms = [
    {
        icon:'devicon-android-plain colored',
        text: 'Android',
    },
    {
        icon:'devicon-linux-plain',
        text: 'Linux',
    },
    {
        icon:'devicon-windows8-original colored',
        text: 'Windows',
    },
    {
        icon:'devicon-apple-original',
        text: 'Apple',
    },
    {
        icon:'devicon-bash-plain',
        text: 'Bash',
    },
]

const frameworks = [
    {
        icon:'devicon-flutter-plain colored',
        text: 'Fluter',
    },
    {
        icon:'devicon-django-plain colored',
        text: 'Django',
    },
    {
        icon:'devicon-react-original colored',
        text: 'React',
    },
    {
        icon:'devicon-laravel-plain colored',
        text: 'Laravel',
    },
    {
        icon:'devicon-nodejs-plain colored',
        text: 'Node JS',
    },
]

const languanges = [
    {
        icon:'devicon-python-plain colored',
        text: 'Python',
    },
    {
        icon:'devicon-java-plain colored',
        text: 'Java',
    },
    {
        icon:'devicon-kotlin-plain colored',
        text: 'Kotlin',
    },
    {
        icon:'devicon-dart-plain colored',
        text: 'Dart',
    },
    {
        icon: 'devicon-go-plain colored',
        text: 'Go'
    },
    {
        icon:'devicon-c-plain colored',
        text: 'C',
    },
    {
        icon:'devicon-javascript-plain colored',
        text: 'Javascrpt',
    },
    {
        icon:'devicon-html5-plain colored',
        text: 'HTML',
    },
    {
        icon:'devicon-css3-plain colored',
        text: 'CSS3',
    },

]

export default function Skills() {
    return(
        <Grid 
            container 
            height={{lg:'85vh', md:'85vh', sm:'85vh', xs:'auto'}}
            spacing={1}
            direction="row"
            justifyContent="center"
            alignContent='flex-start'>
            <Grid item lg={12}>
                <Typography variant='h4' sx={{textDecoration:'underline'}}>
                    Skills
                </Typography>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12} >
                <Typography variant="h6">Platforms</Typography>
                <Grid
                    sx={{
                        border:'dashed 1px #616161',
                        borderRadius:2
                    }}
                    container 
                    direction="row"
                    justifyContent="center">
                        {platforms.map((item,index) => (
                        <Grid key={index} item lg={4} md={2} sm={3} xs={6} sx={{
                            '&:hover': {
                                zoom: 1.02
                            }
                        }}>
                            <Box component='i' className={item.icon}/>
                            <Typography>{item.text}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12} >
                <Typography variant="h6">Programming Languages</Typography>
                <Grid
                    sx={{
                        border:'dashed 1px #616161',
                        borderRadius:2
                    }}
                    container 
                    direction="row"
                    justifyContent="center">
                        {languanges.map((item,index) => (
                        <Grid key={index} item lg={4} md={2} sm={3} xs={6}sx={{
                            '&:hover': {
                                zoom: 1.02
                            }
                        }}>
                            <Box component='i' className={item.icon}/>
                            <Typography>{item.text}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid item lg={4} md={12} sm={12} xs={12} >
                <Typography variant="h6">Frameworks</Typography>
                <Grid
                    sx={{
                        border:'dashed 1px #616161',
                        borderRadius:2
                    }}
                    container 
                    direction="row"
                    justifyContent="center">
                        {frameworks.map((item,index) => (
                        <Grid key={index} item lg={4} md={2} sm={3} xs={6}
                            sx={{
                                '&:hover': {
                                    zoom: 1.02
                                }
                            }}>
                            <Box component='i' className={item.icon}/>
                            <Typography>{item.text}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    )
}